module.exports = __webpack_public_path__ + "img/shogi_2021_pack_3_0007.58f3fc04.png";